const _ = require('lodash');
const PLACEMENT = require('./page-to-placeholder-mapper');

const PAGE_TYPE_BUILDER = {
	HOME_PAGE: {
		build(rrInstance) {
			return new rrInstance.HOME_PAGE();
		},
		placements: [PLACEMENT.HOME_PAGE.placeholder]
	},
	ADD_TO_CART: {
		build(rrInstance, request) {
			const cart = new rrInstance.ADD_TO_CART();
			cart.addItemIdToCart(request.id);
			return cart;
		},
        placements: [PLACEMENT.ADD_TO_CART.placeholder]
	},
	ADD_TO_WISHLIST: {
		build(rrInstance, request) {
			const itemPage = new rrInstance.ITEM_PAGE();
            const productId = request.id ? request.id.toString() : '';
			itemPage.setId(productId);
			itemPage.setName(request.name);
            window.R3_ITEM = itemPage;
			return itemPage;
		},
		placements: [PLACEMENT.ADD_TO_WATCHLIST.placeholder]
	},
    WISHLIST_PAGE: {
        build(rrInstance, request) {
            const wishlist = new rrInstance.WISHLIST_PAGE();
            const items = _.chunk(request.items, this.limit.count)[0];

            _.each(items, (item) => {
                wishlist.addItemId(item.Stockcode);
            });

            window.R3_WISHLIST = wishlist;
            return wishlist;
        },
        limit: {
			count: 15,
			chunkOn: 'items'
		},
        placements: [PLACEMENT.WATCHLIST_PAGE.placeholder]
    },
    CART_PAGE: {
		build(rrInstance, request) {
            const cart = new rrInstance.CART_PAGE();
            _.each(request.items, (item) => {
                cart.addItemId(item);
            });
			return cart;
		},
		placements: [PLACEMENT.CART_PAGE.placeholder]
	},
	CATEGORY_PAGE: {
        build(rrInstance, request) {
            const category = new rrInstance.CATEGORY_PAGE();
			category.setId(request.id);
			category.setName(request.name);
            window.R3_CATEGORY = category;
            return category;
		},
		decorate(common, request) {
            const items = _.chunk(request.items, this.limit.count)[0];
			_.each(items, (item) => {
				common.addItemId(item.PackParentStockCode);
			});
		},
		limit: {
			count: 15,
			chunkOn: 'items'
		},
		placements: [PLACEMENT.CATEGORY_PAGE.placeholder]
	},
    DEPARTMENT_PAGE: {
        build(rrInstance, request) {
            const department = new rrInstance.DEPARTMENT_PAGE();
            department.setId(request.id);
            department.setName(request.name);
            window.R3_CATEGORY = department;
            return department;
        },
        placements: [PLACEMENT.DEPARTMENT_PAGE.placeholder]
    },
	ERROR_PAGE: {
		build(rrInstance) {
			return new rrInstance.ERROR_PAGE();
		},
		placements: [PLACEMENT.ERROR_404_PAGE.placeholder]
	},
	PRODUCT_PAGE: {
		build(rrInstance, request) {
			const product = new rrInstance.PRODUCT_PAGE();
			product.setId(request.id);
			product.setName(request.name);
            window.R3_ITEM = product;
			return product;
		},
        decorate(common, request) {
            common.addCategoryHintId(request.categoryId);
		},
		placements: [PLACEMENT.PRODUCT_PAGE.placeholder]
	},
	MY_PROFILE_PAGE: {
		build(rrInstance) {
			return new rrInstance.MY_PROFILE_PAGE();
		},
		placements: [PLACEMENT.MYACCOUNT_PAGE.placeholder]
	},
    STORE_PAGE: {
		build() {},
		placements: [PLACEMENT.STORE_PAGE.placeholder]
	},
	ORDER_COMPLETE_PAGE: {
		build(rrInstance, request) {
			const purchase = new rrInstance.ORDER_COMPLETE_PAGE;
			purchase.setOrderNumber(request.id);
			_.each(request.items, (item) => {
				purchase.addItemIdPriceQuantity(item.id.toString(), item.price.toString(), item.qty.toString());
			});
            window.R3_PURCHASED = purchase;
			return purchase;
		},
        placements: [PLACEMENT.PURCHASE_COMPLETE.placeholder]
	},
	SEARCH_PAGE: {
		build(rrInstance, request) {
			const search = new rrInstance.SEARCH_PAGE();
			search.setTerms(request.searchTerm);
            const items = _.chunk(request.items, this.limit.count)[0];
			_.each(items, (item) => {
				search.addItemId(item.PackParentStockCode);
			});
			return search;
		},
		limit: {
			count: 15,
			chunkOn: 'items'
		},
		placements: [PLACEMENT.SEARCH_PAGE.placeholder]
	},
    // SEARCH_PAGE_NO_RESULT: {
    //     build(rrInstance, request) {
    //         const search = new rrInstance.SEARCH_PAGE();
    //         search.setTerms(request.searchTerm);
    //         return search;
    //     },
    //     placements: [PLACEMENT.SEARCH_PAGE_NO_RESULT.placeholder]
    // },
	GENERIC_PAGE: {
		build(rrInstance) {
			return new rrInstance.GENERIC_PAGE();
		}
	}
};

function sendEventToRR(pageType, rrInstance, data) {
	this._contextFactory.execute((common) => {
		if (_.isFunction(pageType.decorate)) pageType.decorate(common, data);
		if (!_.isUndefined(pageType.placements)) {
			_.forEach(pageType.placements, (placeholder) => {
				common.addPlacementType(placeholder);
			});
		}
		pageType.build(rrInstance, data);
	});
}

function PageEventFactory(RRContextFactory, RRInstance, Restangular) {
	this._contextFactory = RRContextFactory;
	this._rrInstance = RRInstance;
    this._api = Restangular;
}

// RR script checks for the existance of these objects
// to decide what to send to their server.
// They use the typeof operator
// eg: if (typeof window.R3_COMMON !== "undefined" )
// rather than if (!window.R3_*) so null or false would not work.

// R3_COMMON also needs to be cleared, as placement
// types are registered on it. (R3_COMMON.addPlacementType(...))
// So when the page changes R3_COMMON needs to be reinitialized
// to not have the old placements.
function cleanupR3() {
        if (window.RR && window.RR.unregisterAllPageType) {
            window.RR.unregisterAllPageType('unregister');
        }
        window.R3_COMMON = undefined;
        window.R3_HOME = undefined;
        window.R3_ADDTOCART = undefined;
        window.R3_BRAND = undefined;
        window.R3_CATEGORY = undefined;
        window.R3_DEPARTMENT = undefined;
        window.R3_GENERIC = undefined;
        window.R3_ITEM = undefined;
        window.R3_PURCHASED = undefined;
        window.R3_WISHLIST = undefined;
        window.R3_ADDTOREGISTRY = undefined;
        window.R3_CART = undefined;
        window.R3_ERROR = undefined;
        window.R3_PERSONAL = undefined;
        window.R3_SEARCH = undefined;
}

PageEventFactory.prototype.clickItemEvent = function (linkUrl) {
    // return this._api.oneUrl('linkUrl', linkUrl, { withCredentials: true, 'Access-Control-Allow-Origin': 'integration.richrelevance.com' }).get();

    const xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open('GET', linkUrl, true);
    xhr.setRequestHeader('Content-Type', 'text/plain');

    xhr.onreadystatechange = function () {
      const DONE = 4; // readyState 4 means the request is done.
      const OK = 200; // status 200 is a successful return.
      if (xhr.readyState === DONE) {
        if (xhr.status === OK) {
            const data = JSON.parse(xhr.responseText);
            console.log('Success');
            console.log(data);
        } else {
            console.log('Error: ' + xhr.status); // An error occurred during the request.
        }
      }
  };
    xhr.send(null);
};

PageEventFactory.prototype.send = function (request, newPlacementName = undefined) {
    try {
        cleanupR3();
        const { type, data } = request;
        const pageType = PAGE_TYPE_BUILDER[type];
		if (newPlacementName) {
			pageType.placements = newPlacementName;
		}
        const rrInstance = this._rrInstance;

        if (_.isUndefined(pageType)) {
            throw new Error('Page Type not defined');
        }

        const callRR = sendEventToRR.bind(this);

        callRR(pageType, rrInstance, data);

    } catch (e) {
        console.error(e);
    }

};

module.exports = PageEventFactory;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/richer-relevance/rr-event-factory.js
 **/